module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-tree-container"
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "操作说明",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v(" 说明：该数据来源于商城，仅供排序操作。 ")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "content-bottom-padded",
    staticStyle: {
      "padding-top": "15px",
      "margin-left": "20px"
    }
  }, [_c('el-col', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini",
      "disabled": _vm.isDisable
    },
    on: {
      "click": _vm.updateAreaManage
    }
  }, [_vm._v("保存修改")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "icon": "plus",
      "size": "mini"
    },
    on: {
      "click": _vm.newList
    }
  }, [_vm._v("数据同步")])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tree-background block"
  }, [_c('el-tree', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.areamanageList,
      "default-expand-all": "",
      "expand-on-click-node": false
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('ul', {
          staticClass: "custom-tree-node"
        }, [_c('li', [_vm._v(_vm._s(data.area_id))]), _vm._v(" "), _c('li', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (data.name),
            expression: "data.name"
          }],
          attrs: {
            "placeholder": "区域名称",
            "disabled": "true",
            "readonly": ""
          },
          domProps: {
            "value": (data.name)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(data, "name", $event.target.value)
            }
          }
        }), _vm._v(" "), (data.sort == 1 || data.sort == 2) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.append(data.children, data.sort)
            }
          }
        }, [_vm._v("新增子区域")]) : _vm._e()], 1), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.manager_name))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.manager_mobile))]), _vm._v(" "), _c('li', [_c('span', {
          staticStyle: {
            "padding-right": "100px"
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (data.sort),
            expression: "data.sort"
          }],
          staticStyle: {
            "width": "50px"
          },
          attrs: {
            "placeholder": "排序"
          },
          domProps: {
            "value": (data.sort)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(data, "sort", $event.target.value)
            }
          }
        })])]), _vm._v(" "), _c('li', [_c('span', {
          staticClass: "remove-category",
          on: {
            "click": function($event) {
              return _vm.deleteCategory(node, data)
            }
          }
        }, [_c('i', {
          staticClass: "iconfont icon-trash-alt"
        })])])])
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "add-category"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.append(_vm.areamanageList)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("新增区域")])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "custom-tree-node-title"
  }, [_c('li', [_vm._v("Id")]), _vm._v(" "), _c('li', [_vm._v("地区名称")]), _vm._v(" "), _c('li', [_vm._v("地区经理")]), _vm._v(" "), _c('li', [_vm._v("经理电话")]), _vm._v(" "), _c('li', [_vm._v("排序")]), _vm._v(" "), _c('li', [_vm._v("操作")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b038c10", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b038c10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/areamanage/list.vue
// module id = 2634
// module chunks = 0